import React from 'react';
import Header from './Header';
import Footer from './Footer';
import PricingCard from './PricingCard';
import { FAQ, BOOK_URL, STARTING_PRICE } from '../siteConfig';

function PricingPage() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section className="page-hero">
          <span className="kicker">Pricing</span>
          <h1>Simple pricing. <em>No surprises.</em></h1>
          <p>
            Pick the package that fits, or add individual services from ${STARTING_PRICE}/month. Every package is set up, connected and run for you, with no long-term contract.
          </p>
        </section>
        <section className="section" style={{ paddingTop: 20 }}>
          <PricingCard />
        </section>
        <section className="section faq" style={{ paddingTop: 20 }}>
          <h2>Common questions</h2>
          {FAQ.map((item) => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
          <p className="service-note">
            Ready? <a className="footer-link" href={BOOK_URL}>Book a free call</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PricingPage;
